import { render, staticRenderFns } from "./DraftStatus.vue?vue&type=template&id=2b4eb9c5&scoped=true&"
import script from "./DraftStatus.vue?vue&type=script&lang=js&"
export * from "./DraftStatus.vue?vue&type=script&lang=js&"
import style0 from "./DraftStatus.vue?vue&type=style&index=0&id=2b4eb9c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4eb9c5",
  null
  
)

export default component.exports